export const MOBILE_WEBVIEW_IDENTIFIER = 'webview';
export const COOKIE_FOR_MOBILE_NAME = 'mobile';
//# sourceMappingURL=mobile.js.map